import React from 'react';
import { FileText, Plus } from 'lucide-react';
interface SopPlaceholderProps {
  title: string;
  description: string;
}
export function SopPlaceholder({
  title,
  description
}: SopPlaceholderProps) {
  return <div className="my-4 flex items-center justify-between rounded-lg border bg-card p-4 shadow-sm transition-all hover:shadow-md" data-id="element-249" data-mp="kjgr85di5941">
      <div className="flex items-start gap-4" data-id="element-250" data-mp="fkx3q0j9fp9k">
        <div className="rounded-lg bg-primary/10 p-2 text-primary" data-id="element-251" data-mp="amlu9qwvngrv">
          <FileText className="h-5 w-5" data-id="element-252" data-mp="anwxnpmeumig" />
        </div>
        <div data-id="element-253" data-mp="5uaseiiktkwo">
          <h4 className="font-medium text-foreground" data-id="element-254" data-mp="5tsqb598gcgu">{title}</h4>
          <p className="text-sm text-muted-foreground" data-id="element-255" data-mp="1t8pnrpgaqpy">{description}</p>
        </div>
      </div>
      <button className="flex items-center gap-2 rounded-md border bg-background px-3 py-1.5 text-sm font-medium text-foreground hover:bg-muted transition-colors" data-id="element-256" data-mp="3t0l9kehpxi9k">
        <Plus className="h-4 w-4" data-id="element-257" data-mp="3o2t9gx6x6pua" />
        <span className="hidden sm:inline" data-id="element-258" data-mp="3j1dqdaoaytej">Attach SOP</span>
      </button>
    </div>;
}